import axios from 'axios';
import clientConfig from '../client-config';
import setAuthToken from '../utils/setAuthToken';

export async function getActiveSubscriptions() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    const res = await axios.get(
      clientConfig.backendHOST + '/subscriptions/valid',
      '',
      clientConfig.axios_header
    );
    let items = [];

    res.data.map((item) => {
      items.push({
        subscription_price_id: item.id,
        subscription_code: item.subscription.subscription_code,
        subscription_text: item.subscription.subscription_text,
        subscription_description: item.subscription.subscription_description,
        price_details: item.price_details,
        price_descr: item.detailed_descr,
        price_highlight: item.price_highlight,
        price: item.price,
        valid_days: item.valid_days,
      });
    });

    if (res.status === 200) {
      return items;
    }
  } catch (err) {
    return [];
  }
}

export async function getAvailableSubscriptions() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    const res = await axios.get(
      clientConfig.backendHOST + '/subscriptions/available',
      '',
      clientConfig.axios_header
    );
    let items = [];
    res.data.map((item) => {
      items.push({
        subscription_price_id: item.id,
        subscription_code: item.subscription.subscription_code,
        subscription_text: item.subscription.subscription_text,
        subscription_description: item.subscription.subscription_description,
        price_details: item.price_details,
        price_descr: item.detailed_descr,
        price_highlight: item.price_highlight,
        price: item.price,
        valid_days: item.valid_days,
      });
    });

    if (res.status === 200) {
      return items;
    }
  } catch (err) {
    return [];
  }
}
export async function getActiveOrder() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    const res = await axios.get(
      clientConfig.backendHOST + '/subscriptions/open',
      '',
      clientConfig.axios_header
    );

    if (res.status === 200) {
      return res;
    }
    if (res.status === 403) {
      console.log('error 403');
    }
  } catch (err) {
    return { authFailed: true };
  }
}

export async function getPendingOrder() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    const res = await axios.get(
      clientConfig.backendHOST + '/subscriptions/pending',
      '',
      clientConfig.axios_header
    );

    if (res.status === 200) {
      return res;
    }
    if (res.status === 403) {
      console.log('error 403');
    }
  } catch (err) {
    return { authFailed: true };
  }
}

export async function checkoutOrder(checkoutData) {
  // Send request
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  if (localStorage.token) {
    let res;
    try {
      res = await axios.post(
        clientConfig.backendHOST + '/subscriptions/subscriptionRequest',
        checkoutData,
        config
      );
    } catch (e) {
      console.error('error', e);
    }

    if (res) {
      if (res.status === 200) {
        return {
          isOk: true,
          data: res,
        };
      }
    } else {
      return {
        isOk: false,
      };
    }
  } else {
    return {
      isOk: false,
    };
  }
}

export async function getOrderInformation(id) {
  // Send request
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  if (localStorage.token) {
    let res;
    try {
      res = await axios.get(
        clientConfig.backendHOST + '/subscriptions/subscriptionRequest',
        {
          params: {
            key: id,
          },
        },
        config
      );
    } catch (e) {
      console.error('error', e);
    }

    if (res) {
      if (res.status === 200) {
        return {
          isOk: true,
          data: res.data,
        };
      }
    } else {
      return {
        isOk: false,
      };
    }
  } else {
    return {
      isOk: false,
    };
  }
}

export async function getOrderInformationAfterPayment(barionKey) {
  // Send request
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  if (localStorage.token) {
    let res;
    try {
      res = await axios.get(
        clientConfig.backendHOST + '/subscriptions/subscriptionRequest',
        {
          params: {
            barionKey: barionKey,
          },
        },
        config
      );
    } catch (e) {
      console.error('error', e);
    }

    if (res) {
      if (res.status === 200) {
        return {
          isOk: true,
          data: res.data,
        };
      }
    } else {
      return {
        isOk: false,
      };
    }
  } else {
    return {
      isOk: false,
    };
  }
}

export async function cancelSubscriptionRequest(paymentData) {
  // Send request
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  if (localStorage.token) {
    let res;
    try {
      res = await axios.post(
        clientConfig.backendHOST + '/subscriptions/cancelSubscriptionRequest',
        paymentData,
        config
      );
    } catch (e) {
      console.error('error', e);
      return {
        isOk: false,
        status: e.response.status,
        error: e,
      };
    }

    if (res) {
      if (res.status === 200) {
        return {
          isOk: true,
          data: res,
        };
      } else {
        return {
          isOk: false,
          status: res.status,
        };
      }
    } else {
      return {
        isOk: false,
      };
    }
  } else {
    return {
      isOk: false,
      status: 403,
    };
  }
}

export async function activateManual(requestId) {
  // Send request
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  if (localStorage.token) {
    let res;
    try {
      res = await axios.post(
        clientConfig.backendHOST + '/invoice/manualActivate',
        { subscriptionRequestId: requestId },
        config
      );
    } catch (e) {
      console.error('error', e);
      return {
        isOk: false,
        error: e,
      };
    }

    if (res) {
      if (res.status === 200) {
        return {
          isOk: true,
          data: res,
        };
      }
    } else {
      return {
        isOk: false,
      };
    }
  } else {
    return {
      isOk: false,
    };
  }
}

export async function getPriceLimit(idPrice) {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    const res = await axios.get(
      clientConfig.backendHOST + '/subscriptions/subscriptionLimit',
      {
        params: { priceId: idPrice }, // Így lesz belőle query string!
        ...clientConfig.axios_header, // ha a header is object, így egyesítheted
      }
    );

    if (res.status === 200) {
      return { remaining: res.data.remaining, useLimit: res.data.useLimit };
    }
  } catch (err) {
    console.error('Error fetching price limit:', err);
    return { remaining: -1, useLimit: false };
  }
}
